import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
const defaultOption = {
    exclude: ['g_importantMarks'],
};
export class ClearFormatPlugin {
    constructor(opt = {}) {
        this.name = 'clearFormat';
        this.clearInline = () => {
            this.editor.selection().removeMarkExcluding(this.opt.exclude);
        };
        this.clearBlock = () => {
            this.editor.selection().resetTextBlock();
        };
        this.clearAll = () => {
            this.editor.batch(() => {
                this.clearInline();
                this.clearBlock();
            });
        };
        this.opt = {
            ...defaultOption,
            ...opt,
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                clearInline: this.clearInline,
                clearBlock: this.clearBlock,
                clearAll: this.clearAll,
            },
            shortcuts: {
                'Mod-\\': this.clearAll,
                'Shift-Mod-\\': this.clearInline,
            },
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: this.editor.t('清除格式'),
            shortcut: 'Mod-\\',
            onclick: (e) => {
                this.editor.focus();
                if (e.shiftKey) {
                    this.clearInline();
                }
                else {
                    this.clearAll();
                }
            },
        }).append(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.clearIcon),
        }));
        return btn;
    }
}
//# sourceMappingURL=index.js.map